module.exports = __webpack_public_path__ + "static/media/Report.37bc875a.svg";